import SearchFormController from "./search_form_controller"

export default class extends SearchFormController {
  static targets = ["providerField", "serviceTypeField", "bandwidthField", "sortField"]

  connect() {
    super.connect()
    this.entityTypeValue = 'supplier_quote'
  }
}
